import { render, staticRenderFns } from "./ContentManagementView.vue?vue&type=template&id=4ffa1a17&"
import script from "./ContentManagementView.vue?vue&type=script&lang=js&"
export * from "./ContentManagementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports